import r, { useState as m, useEffect as c } from "react";
import { VGSElement as I } from "@amenitiz/payment-frontend";
import y from "./index269.mjs";
import H from "./index79.mjs";
import { giftCardCodeAtom as N } from "./index34.mjs";
import { selectedClientDetailsAtom as O } from "./index55.mjs";
import { setCurrentStepAtom as j } from "./index25.mjs";
import { insurancePriceAtom as B } from "./index62.mjs";
import { useAtomValue as i, useSetAtom as F } from "jotai";
import { useErrorHandler as q } from "./index122.mjs";
import { useErrorAlert as z } from "./index121.mjs";
import { usePayment as J } from "./index123.mjs";
import { useClientDetails as K } from "./index149.mjs";
import { useSalesTermsShow as L, useTermsAndConditionsShow as M } from "./index102.mjs";
import { useHotelConfig as Q } from "./index93.mjs";
import { PaymentType as U } from "./index232.mjs";
import { Toast as W, ToastState as X } from "./index90.mjs";
const Y = (o) => o === "sandbox" || o === "live", pe = ({
  cartItems: o,
  giftCards: l,
  optedForInsurance: u
}) => {
  const [d, v] = m(), [_, A] = m(), [T, f] = m(!1), p = i(B), b = i(O), h = i(N), k = q(), n = F(j), s = z(), { payment: g, setPayment: w } = J(), { setClientDetails: a } = K(), { setShowSalesTerms: x } = L(), { setShowTermsAndConditions: D } = M(), { clientBookingToken: E, vgsVaultId: C, vgsEnvironment: R } = Q(), S = R || "sandbox";
  c(() => {
    const { vgs_credit_card_token: e, vgs_cvc_token: t } = g;
    e && t && n(3);
  }, [g, n]);
  const V = (e) => {
    w({
      amount: d,
      currency: _,
      name: e.card_name,
      expiry_month: e.card_expirationDate.slice(0, 2),
      expiry_year: e.card_expirationDate.slice(-2),
      vgs_credit_card_token: e.card_number,
      vgs_cvc_token: e.card_cvc
    });
  }, P = () => {
    f(!0);
  };
  return c(() => {
    async function e() {
      try {
        const t = await H.validateCart(
          {
            items: o,
            gift_cards: l,
            customer: b,
            clientBookingToken: E,
            payment_type: U.CREDIT_CARD,
            opted_for_insurance: u || !1,
            gift_card_code: h
          },
          p
        );
        if (!t.success) {
          if (t.error_code) {
            const G = k(
              t.error_code,
              n
            );
            return s(G);
          }
          return s();
        }
        v(Number(t.data.amount) * 100), A(t.data.currency);
      } catch (t) {
        console.error(t), s();
      }
    }
    e();
  }, [
    o,
    l,
    s,
    n,
    a,
    E,
    u,
    p
  ]), c(() => {
    a({
      sales_terms_accepted: !0
    });
  }, [a]), C && d && _ ? /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
    I,
    {
      vaultId: C,
      environment: Y(S) ? S : "sandbox",
      onSubmit: V,
      onError: P,
      showTermsAndConditions: () => D(!0),
      showSalesTerms: () => x(!0),
      onAcceptSalesTerms: (e) => a({
        sales_terms_accepted: e
      })
    }
  ), T ? /* @__PURE__ */ r.createElement(
    W,
    {
      index: 0,
      message: /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("p", { className: y["error-title"] }, I18n.t("booking_engine.information.something_went_wrong")), /* @__PURE__ */ r.createElement("p", { className: y["error-subtitle"] }, I18n.t("booking_engine.information.payment_issue"))),
      state: X.ERROR,
      onClose: () => f(!1)
    }
  ) : null) : null;
};
export {
  pe as VgsContainer
};
